import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  TemplateRef,
} from '@angular/core';

import { FileValidationService } from '..';
import { defaultSizeLimit } from '../file-upload-const';

@Component({
  selector: 'app-file-upload-button',
  templateUrl: './file-upload-button.component.html',
  styleUrls: ['./file-upload-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploadButtonComponent {
  @Input({ required: true }) uploadButtonTemplate: TemplateRef<any>;
  @Input({ required: true }) isMultiple: boolean;
  @Input() accept: string;
  @Input() sizeLimit = defaultSizeLimit;
  @Input() imageSizeLimit = defaultSizeLimit;

  @Output() filesChange = new EventEmitter<File[]>();

  fileInputElement: HTMLInputElement;
  publicContext = {
    $implicit: this.onAddFiles.bind(this),
  };

  constructor(private fileValidationService: FileValidationService) {}

  @ViewChild('fileInput', { static: true }) set fileRef(
    elementRef: ElementRef
  ) {
    this.fileInputElement = elementRef.nativeElement;
  }

  onAddFiles(): void {
    this.fileInputElement.click();
  }

  onFilesAdded(fileList: FileList): void {
    const files: File[] = Array.from(fileList || []);

    const validFiles = this.fileValidationService.validateFiles(
      files,
      this.accept,
      this.sizeLimit,
      this.imageSizeLimit
    );

    this.fileInputElement.value = null;

    this.filesChange.emit(validFiles);
  }
}
